export default __webpack_public_path__ + "static/jeanlucweb-thin_broad-ee579b2eacb955791c3c747744aa3c20.woff";